module.exports = __webpack_public_path__ + "img/sidebar-icon-academic.42264f1e.svg";